import { useAppContext } from './AppContext'

export const useWhatsAppConfig = () => {
  const { blogFeatureConfigData } = useAppContext();

  const whatsappItem = blogFeatureConfigData?.find((item: any) => item?.feature?.feature_key === "enable_blog_contact_whatsapp")

  const whatsAppConfig = whatsappItem
    ? whatsappItem?.feature?.configuration?.value[0]?.value === 'true'
      ? true
      : false
    : false;

  return whatsAppConfig;
}